"use client"; // nếu bạn dùng hook client-side
import { useEffect } from "react";

export default function ErrorPage({
  error,
  reset,
}: {
  error: Error;
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <main style={{ textAlign: "center", padding: "4rem" }}>
      <h1>Đã xảy ra lỗi!</h1>
      <pre>{error.message}</pre>
      <button onClick={() => reset()}>Thử lại</button>
    </main>
  );
}
